import {
  fetchMetaGamesCount,
  instantMetaGameCompleted,
} from '@bonanza-social/meta-games';
import { startListening } from '@bonanza-social/toolkit/state';

startListening({
  actionCreator: instantMetaGameCompleted,
  effect: (_, { dispatch }) => {
    dispatch(fetchMetaGamesCount());
  },
});
